import { axios } from '@Root/API'

export const get = (engagementId, collaborativeId) => {
	return axios.get(`student-engagement/${engagementId}/collaborative-provision/${collaborativeId}`)
}
